export const SectionLabel = ({ children, light = false }) => (
  <div className="flex items-center gap-3 mb-5">
    <span className="h-px w-8 bg-accent" />
    <span
      className={`text-xs font-semibold uppercase tracking-[0.25em] ${light ? "text-cream/70" : "text-navy/60"}`}
    >
      {children}
    </span>
  </div>
);
